/**
 * Qué decirle a la persona cuando el acceso falla (A5, auditoría 2026-10-02).
 *
 * Antes todo acababa en `detail || 'No se pudo completar el acceso'`: con el
 * servidor caído (un 502 de nginx es HTML, sin `detail`) la persona creía que su
 * contraseña estaba mal y la reintentaba hasta que la bloqueaban. Lo importante
 * es separar «no se comprobó» de «se comprobó y no vale».
 */
const NO_SE_COMPROBO = 'Tu contraseña no se comprobó: inténtalo de nuevo en unos minutos.';

export function mensajeErrorAcceso(err, paso) {
  const r = err?.response;
  const detail = typeof r?.data?.detail === 'string' ? r.data.detail : null;
  if (!r) {
    const sinRed = typeof navigator !== 'undefined' && navigator.onLine === false;
    return sinRed
      ? 'No tienes conexión a internet. Revisa tu red e inténtalo de nuevo.'
      : `No pudimos contactar con Orvian. ${NO_SE_COMPROBO}`;
  }
  if (r.status === 401) {
    return paso === 'mfa'
      ? 'Código incorrecto. Usa el más reciente de tu app y revisa que la hora del teléfono esté en automático.'
      : 'Correo o contraseña incorrectos. Recuerda que es la misma contraseña de tu buzón de correo.';
  }
  if (r.status === 503 && detail) return `${detail} Tu contraseña no se comprobó.`;
  if (r.status >= 500) return `Orvian no responde ahora mismo. ${NO_SE_COMPROBO}`;
  return detail || 'No se pudo completar el acceso.';   // 403 bloqueos y 429 traen su propio texto
}
